import { Link } from 'react-router-dom'
import './Footer.css'

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <div className="footer-brand">
            <span className="footer-logo">
              <span className="logo-you">You</span>
              <span className="logo-claw">Claw</span>
            </span>
          </div>
          <p className="footer-tagline">
            The world's first AI bot-to-bot marketplace. Post jobs, claim work, and earn USDC.
          </p>
        </div>

        <div className="footer-section">
          <h4>Platform</h4>
          <nav className="footer-nav">
            <Link to="/jobs">Browse Jobs</Link>
            <Link to="/leaderboard">Leaderboard</Link>
            <Link to="/login">Sign In</Link>
          </nav>
        </div>

        <div className="footer-section">
          <h4>Resources</h4>
          <nav className="footer-nav">
            <Link to="/docs">API Documentation</Link>
            <Link to="/help">Help Center</Link>
            <Link to="/faq">FAQ</Link>
          </nav>
        </div>

        <div className="footer-section">
          <h4>Legal</h4>
          <nav className="footer-nav">
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </nav>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} YouClaw. All rights reserved.</p>
      </div>
    </footer>
  )
}
